/**
 * В какой версии расширения сделана тема: в 4.0 (новые дизайны виджетов и
 * новые виджеты) или раньше. По этому полю фильтруется маркет тем.
 *
 * Признаки 4.0 (mavo-dash, коммит 7193681):
 *  - формат данных v8 (Migrations/applyMigrations.js, LATEST_VERSION = 8):
 *    расширение 4.0 сохраняет его в каждую тему;
 *  - у виджета задан дизайн (skin) — их до 4.0 не было;
 *  - есть виджет, который пользователи впервые получили в 4.0
 *    (data/screenshots/report-4-new-widgets.md, [R1]).
 *
 * Номер формата у старых тем не показатель возраста: 5, 6 и 7 встречаются
 * с 2020 года вперемешку, поэтому смотрим только на «8 и больше».
 */

export const MADE_WITH_V4 = '4.0';
export const MADE_WITH_CLASSIC = 'classic';
export const MADE_WITH_VALUES = [MADE_WITH_V4, MADE_WITH_CLASSIC];

const V4_DATA_VERSION = 8;

const NEW_IN_V4 = [
	'DailyFocusModel',
	'NewsFeedModel',
	'FactsModel',
	'ChessPuzzleModel',
	'CurrencyModel',
	'CanvasModel',
	'PomodoroModel',
	'FlashCardsModel',
	'TimetableModel',
];

/** Все виджеты темы, включая вложенные контейнеры */
export function collectWidgets(node, out = []) {
	if (!node || typeof node !== 'object') {
		return out;
	}

	const list = Array.isArray(node.widgets) ? node.widgets : [];

	list.forEach(widget => {
		if (widget && typeof widget === 'object') {
			out.push(widget);
			if (Array.isArray(widget.widgets)) {
				collectWidgets(widget, out);
			}
		}
	});

	return out;
}

/**
 * @param {string|Object} appJSON тема как строка или уже разобранный объект
 * @returns {string} MADE_WITH_V4 | MADE_WITH_CLASSIC
 */
export function detectMadeWith(appJSON) {
	let json = appJSON;

	if (typeof appJSON === 'string') {
		try {
			json = JSON.parse(appJSON);
		} catch (e) {
			return MADE_WITH_CLASSIC;
		}
	}

	if (!json || typeof json !== 'object') {
		return MADE_WITH_CLASSIC;
	}

	if (Number(json.version) >= V4_DATA_VERSION) {
		return MADE_WITH_V4;
	}

	const isV4 = collectWidgets(json.widgets).some(
		widget => !!widget.skin || NEW_IN_V4.indexOf(widget.className) !== -1,
	);

	return isV4 ? MADE_WITH_V4 : MADE_WITH_CLASSIC;
}

/**
 * Значение фильтра из запроса: только из белого списка, иначе — без фильтра.
 * @param {string} value
 * @returns {string|null}
 */
export function normalizeMadeWith(value) {
	return MADE_WITH_VALUES.indexOf(value) !== -1 ? value : null;
}
